import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { resetAllStores } from '../_core/resetAllStores';
import { Store } from '../_core/types/Store';
import useApiStore from '../apiStore/useApiStore';
import useRouteStore from '../routeStore/useRouteStore';
import useUserStore from '../userStore/useUserStore';
import { signOutStore } from './signOutStore';
import { SignOutState } from './types/SignOutState';

const useSignOutStore: Store<SignOutState> = createStore({
  creator: signOutStore({
    resetAllStores,
    useApiStore: lazyDependency(() => useApiStore),
    useRouteStore: lazyDependency(() => useRouteStore),
    useUserStore: lazyDependency(() => useUserStore),
  }),
  id: 'signOut',
  middlewares: {
    devtools: true,
  },
});

export default useSignOutStore;
